import { render, staticRenderFns } from "./FormiumFieldEditor.vue?vue&type=template&id=5beb3209"
import script from "./FormiumFieldEditor.vue?vue&type=script&lang=js"
export * from "./FormiumFieldEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports